import { formatDateShort } from '@/app/utils/formatDate';
import type { AgreementInvoice } from '../types/agreements.types';

export const isReversed = (invoice: Pick<AgreementInvoice, 'status'>): boolean => invoice.status === 'reversed';

export function reversalSummary(invoice: AgreementInvoice): string {
    const by = invoice.reversedByName ?? 'an unknown user';
    const parsed = invoice.reversedAt ? new Date(invoice.reversedAt) : null;
    return parsed && !Number.isNaN(parsed.getTime())
        ? `Reversed by ${by} on ${formatDateShort(invoice.reversedAt as string)}`
        : `Reversed by ${by}`;
}

interface ReverseAvailabilityInput {
    invoice: Pick<AgreementInvoice, 'status' | 'invoicingDealerId'>;
    isInternal: boolean;
    candidateDealerIds: readonly string[];
    agreementActive: boolean;
}

/** Visibility only; the server enforces every rule and the permission is checked by the guard. */
export const reverseAvailability = ({
    invoice,
    isInternal,
    candidateDealerIds,
    agreementActive,
}: ReverseAvailabilityInput): boolean =>
    agreementActive &&
    invoice.status === 'submitted' &&
    (isInternal || candidateDealerIds.includes(invoice.invoicingDealerId));

export const invoiceCardId = (invoiceId: string): string => `submitted-invoice-${invoiceId}`;
